const JourneyStatusEnum = {
  new: 'new',
  accepted: 'accepted',
  looking_for_drivers: 'looking_for_drivers',
  on_the_way: 'on_the_way',
  arrived: 'arrived',
  serving: 'serving',
  done: 'done',
  cancelled: 'cancelled',
  failed: 'failed',
  no_show: 'no_show',
  car_not_found: 'car_not_found',
} as const;

const EventNameEnum = {
  [JourneyStatusEnum.looking_for_drivers]: JourneyStatusEnum.looking_for_drivers,
  [JourneyStatusEnum.on_the_way]: JourneyStatusEnum.on_the_way,
  [JourneyStatusEnum.arrived]: JourneyStatusEnum.arrived,
  [JourneyStatusEnum.serving]: JourneyStatusEnum.serving,
  [JourneyStatusEnum.done]: JourneyStatusEnum.done,
  [JourneyStatusEnum.cancelled]: JourneyStatusEnum.cancelled,
  [JourneyStatusEnum.failed]: JourneyStatusEnum.failed,
  [JourneyStatusEnum.car_not_found]: JourneyStatusEnum.car_not_found,
  extrastop: 'extrastop',
} as const;

type TJourneyStatus = keyof typeof JourneyStatusEnum;
type TEventName = keyof typeof EventNameEnum;

interface IChauffeur {
  id: string;
  firstName: string;
  lastName: string;
}

interface IVehicle {
  id: string;
  make: string;
  model: string;
  licensePlate: string;
}

interface IBreakdownItem {
  name: string;
  value: number;
}

interface IEvent {
  name: TEventName;
  date: Date;
}

interface IJourney {
  id: string;
  number: number;
  status: TJourneyStatus;
  service: string;
  currencyCode: string;
  timezone: string;
  isASAP: boolean;
  completedAt?: Date;
  pickupAt?: Date;
  duration?: number;
  chauffeur?: IChauffeur;
  vehicle?: IVehicle;
  breakdown?: IBreakdownItem[];
  events?: IEvent[];
  price?: number;
  isTotalDefined: boolean;
}

export type { IJourney, IEvent, TJourneyStatus, TEventName };
export { JourneyStatusEnum, EventNameEnum };
